module.exports = __webpack_public_path__ + "img/trial4-1.904b9d2f.png";